<template>
  <ButtonBase :text="text" class="btn--secondary" @click-button="onClick" />
</template>

<script>
import ButtonBase from '../../atoms/buttons/ButtonBase.vue'
export default {
  components: { ButtonBase },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click-secondary-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn--secondary {
  background-color: $white;
  color: $primary;
  border-color: $primary;

  a {
    color: $primary;
  }
}
</style>
